<ion-tabs>
  <ion-tab-bar slot="bottom" *ngIf="!isTvScreenView">
    <ion-tab-button *ngIf="isCustomer" (click)="onScanClick()">
      <ion-icon name="scan-circle-outline"></ion-icon>
      <ion-label>Scan</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="customer" *ngIf="isCustomer">
      <ion-icon name="fast-food-outline"></ion-icon>
      <ion-label>Food</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="resto-admin" *ngIf="isRestoAdmin">
      <ion-icon name="restaurant-outline"></ion-icon>
      <ion-label>Restaurants</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="admin" *ngIf="isAdmin">
      <ion-icon name="construct-outline"></ion-icon>
      <ion-label>Admin</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
